/* eslint-disable no-empty */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import _ from 'underscore';
import { titleize } from 'underscore.string';

import { validateLoadDetailsV2 } from 'helpers/booking/validation';

import CargomaticModal from 'components/v2/modal';
import { isValid } from 'components/modules/booking/BookingHelper';
import LoadDetailsForm from 'components/load/LoadDetailsForm';
import { DEFAULT_WEIGHT_UNIT } from 'utils/localization/types';

function renderErrors(errors) {
  if (Object.keys(errors).length === 0) {
    return null;
  }
  return (
    <div className="mt-4 text-red-700 bg-red-50">
      {Object.keys(errors).map((key) => (
        <li key={key}>{errors[key]}</li>
      ))}
    </div>
  );
}

const getInitialState = (props) => {
  return {
    totalWeight: props.shipment ? props.shipment.weight || 0 : 0,
    weight_units: props.shipment
      ? props.shipment.weight_units || DEFAULT_WEIGHT_UNIT
      : DEFAULT_WEIGHT_UNIT,
    stop: props.stop || {},
    loads: props.stop ? props.stop.loads || [] : [],
    full_truckload: props.stop ? props.stop.full_truckload || false : false,
    errors: {},
  };
};

class EditLoadModal extends Component {
  constructor(props) {
    super(props);
    this.state = getInitialState(props);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (!_.isEqual(this.props.stop, nextProps.stop)) {
      this.setState({
        stop: nextProps.stop,
        loads: nextProps.stop.loads,
        full_truckload: nextProps.stop.full_truckload,
      });
    }
    if (this.props.shipment.weight !== nextProps.shipment.weight) {
      this.setState({ totalWeight: nextProps.shipment.weight });
    }
  }

  close() {
    this.props.onHide();
    this.setState(getInitialState(this.props));
  }

  isMultiStop = () => {
    return this.props.shipment.stops.length > 2;
  };

  validateLoad() {
    let valid = true;
    const { loads, full_truckload, totalWeight: weight, weight_units } = this.state;
    const { t } = this.props;
    const loadDetails = validateLoadDetailsV2({
      loads,
      full_truckload,
      weight,
      weight_units,
      t,
    });
    if (!isValid(loadDetails)) {
      valid = false;
      this.setState({ errors: { loadDetails } });
    } else {
      this.setState({ errors: {} });
    }
    return valid;
  }

  addLoad = (newLoads) => {
    this.setState({ loads: newLoads });
  };

  updateTotalWeight = () => {
    this.setState((prevState) => {
      return {
        totalWeight: prevState.loads.reduce((total, load) => {
          return total + load.weight;
        }, 0),
      };
    });
  };

  handleRemoveLoad = (newLoads, i) =>
    this.setState({ loads: newLoads }, this.updateTotalWeight);

  handleLoadFieldChange = (newLoads, field, value, index) => {
    this.setState({ loads: newLoads }, () => {
      if (field === 'weight') {
        const totalWeight = newLoads.reduce((total, load) => {
          return total + load.weight;
        }, 0);
        this.setState({ totalWeight });
      }
      if (field === 'weight_units') {
      }
    });
  };

  handleLoadSave() {
    if (this.validateLoad()) {
      const { totalWeight, loads, full_truckload } = this.state;
      this.props.onUpdateLoad(
        this.props.stop,
        totalWeight,
        loads,
        full_truckload,
        false,
      );
      this.setState(getInitialState(this.props));
    }
  }

  handleStopLoadSave() {
    if (this.validateLoad()) {
      const { totalWeight, loads, full_truckload } = this.state;
      // Save only to this stop
      this.props.onUpdateLoad(
        this.props.stop,
        totalWeight,
        loads,
        full_truckload,
        true,
      );
      this.setState(getInitialState(this.props));
    }
  }

  onTotalShipmentWeightChange = (value) => {
    this.setState({ totalWeight: value });
  };

  getNewBody = () => {
    const { loads } = this.state;
    return (
      <div>
        {this.renderLoadDetailErrors()}
        <LoadDetailsForm
          loads={loads}
          fullTruckload={this.state.full_truckload}
          totalShipmentWeight={this.state.totalWeight}
          shipmentWeightUnit={this.state.weight_units}
          addLoad={this.addLoad}
          onRemoveLoad={this.handleRemoveLoad}
          onLoadFieldChange={this.handleLoadFieldChange}
          onTotalShipmentWeightChange={this.onTotalShipmentWeightChange}
        />
      </div>
    );
  };

  getFooter = () => {
    const { t } = this.props;
    return (
      <div>
        <button className="button" onClick={this.close.bind(this)}>
          {t('CLOSE')}
        </button>
        {this.isMultiStop() && (
          <button
            className="mr-4 button button-green"
            onClick={this.handleStopLoadSave.bind(this)}
          >
            {t('SAVE_TO_THIS_STOP')}
          </button>
        )}
        <button
          className="button button-green"
          onClick={this.handleLoadSave.bind(this)}
        >
          {titleize(t('SAVE'))}
        </button>
      </div>
    );
  };

  renderLoadDetailErrors() {
    const {
      errors: { loadDetails },
    } = this.state;
    if (!loadDetails) {
      return null;
    }
    const otherErrors = [];
    const nonLoadItemErrors = _.omit(loadDetails, 'loadItemErrors');
    if (!_.isEmpty(nonLoadItemErrors)) {
      otherErrors.push(renderErrors(nonLoadItemErrors));
    }
    return otherErrors.concat(
      loadDetails.loadItemErrors.map((itemError) => {
        return renderErrors(itemError);
      }),
    );
  }

  render() {
    if (_.isEmpty(this.props.stop)) {
      return null;
    }
    const { t } = this.props;
    return (
      <CargomaticModal
        title={t('LOAD_DETAILS')}
        style={{ top: '10%' }}
        dialogClassName="modal-fit-content"
        show={this.props.show}
        onHide={this.close.bind(this)}
        body={this.getNewBody()}
        footer={this.getFooter()}
      />
    );
  }
}

EditLoadModal.propTypes = {
  shipment: PropTypes.object.isRequired,
  stop: PropTypes.object.isRequired,
  onHide: PropTypes.func.isRequired,
  onUpdateLoad: PropTypes.func.isRequired,
  show: PropTypes.bool.isRequired,
};

export default withTranslation()(EditLoadModal);
